import React, { useEffect } from "react";
import { updateMeta, updatePropertyMeta } from "../utils/metaUtils";

interface MetaHeadProps {
  title: string;
  description?: string | null;
  keywords?: string | null;
}

const MetaHead: React.FC<MetaHeadProps> = ({
  title,
  description,
  keywords,
}) => {
  useEffect(() => {
    document.title = title;

    const defaultDescription =
      "StreakSpark is a free habit building app and habit tracking app. Build daily streaks, track habits, set reminders, and visualize your progress – completely free!";
    const defaultKeywords =
      "habit building app, habit tracking app, free habit tracker, streak counter, build habits, daily habits, goal setting, reminders, calendar tracking, personal development, productivity app, self-reliance";

    const finalDescription = description || defaultDescription;
    const finalKeywords = keywords || defaultKeywords;

    updateMeta("description", finalDescription);
    updateMeta("keywords", finalKeywords);

    // Open Graph tags
    updatePropertyMeta("og:title", title);
    updatePropertyMeta("og:description", finalDescription);
    updatePropertyMeta("og:image", "https://streakspark.in/logo512.png");
    updatePropertyMeta("og:type", "website");
    updatePropertyMeta("og:site_name", "Streak Spark");

    // Twitter tags
    updatePropertyMeta("twitter:card", "summary_large_image");
    updatePropertyMeta("twitter:site", "@streakspark");
    updatePropertyMeta("twitter:title", title);
    updatePropertyMeta("twitter:description", finalDescription);
    updatePropertyMeta("twitter:image", "https://streakspark.in/logo512.png");
  }, [title, description, keywords]);

  return null;
};

export default MetaHead;
